// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxsmallOnWide-superElipse-d3258bf8","strokeWidth":"super-ellipse-skins-xxsmallOnWide-strokeWidth-39da6ba0"};